/** React Query keys for the announcements a member can read. */
export const announcementKeys = {
  all: ['announcements'] as const,
};
